export default function LandingHeroStage() {
  return (
    <figure className="pc-landing-hero-stage" data-media-slot="hero" data-media-state="asset">
      <img
        className="pc-landing-hero-stage__image"
        src="/landing-media/performance-care-hero-phone-v04-960.webp"
        srcSet="/landing-media/performance-care-hero-phone-v04-960.webp 960w, /landing-media/performance-care-hero-phone-v04-1600.webp 1600w"
        sizes="(max-width: 400px) 100vw, (max-width: 760px) 400px, (max-width: 1100px) 360px, 430px"
        alt="Performance Care Player-App mit Gamepower und organisiertem Tagesablauf"
        width={1600}
        height={3195}
        loading="eager"
        fetchPriority="high"
        decoding="async"
      />
    </figure>
  );
}
